document.addEventListener("DOMContentLoaded", () => {
  /* =====================================================
     ScrollHint
  ===================================================== */
  new ScrollHint('.js-scrollable', {
    scrollHintIconAppendClass: 'scroll-hint-icon-white',
    applyToParents: true,
    i18n: {
      scrollable: 'スクロールできます'
    }
  });


  /* =====================================================
     MV 初期アニメーション
  ===================================================== */
  document.querySelector(".mv_textBox")?.classList.add("scrollin");
  document.querySelector(".mv")?.classList.add("scrollin");


  /* =====================================================
     タブ切替
  ===================================================== */
  document.querySelectorAll(".typeTab_area .tab").forEach(tab => {
    tab.addEventListener("click", function () {
      document.querySelectorAll(".typeTab_area .tab").forEach(t => {
        t.classList.remove("active");
      });
      this.classList.add("active");
      const id = this.id;
      [".tab-content_lifeinfo"].forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          el.classList.remove("active");
        });
      });
      document.querySelectorAll("." + id).forEach(el => {
        el.classList.add("active");
      });
    });
  });

  /* =====================================================
     GSAP: 中央画像拡大アニメーション
  ===================================================== */

  gsap.registerPlugin(ScrollTrigger, Observer);

  const centerImg = document.querySelector('.loc_center_image_wrapper');
  const centerText = document.querySelector('.loc_center_text'); // 文字要素を取得
  let st; // ScrollTriggerインスタンスを保持する変数
  const mm = gsap.matchMedia();



  mm.add("(min-width: 768px)", () => {


    function initCenterImageAnimation() {
      if (!centerImg) return;
      if (st) st.kill();

      const vh = window.innerHeight;
      const vw = window.innerWidth;
      const squareSize = vw * 0.15;

      // 数値を％付きの文字列として用意
      const tb = `${((vh - squareSize) / 2 / vh) * 100}%`;
      const sd = `${((vw - squareSize) / 2 / vw) * 100}%`;

      // 1. 初期状態をセット (4つの値を明示)
      gsap.set(centerImg, {
        clipPath: `inset(${tb} ${sd} ${tb} ${sd})`
      });

      if (centerText) {
        gsap.set(centerText, { autoAlpha: 0, y: 20 });
      }

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".loc_scroll-section",
          start: "top top",
          end: "bottom bottom",
          scrub: 0.1,
          invalidateOnRefresh: true
        }
      });

      // 2. アニメーション開始
      tl.fromTo(centerImg,
        {
          clipPath: `inset(${tb} ${sd} ${tb} ${sd})`
        },
        {
          clipPath: `inset(0% 0% 0% 0%)`, // テンプレートリテラルで明示
          ease: "none"
        }
      );

      if (centerText) {
        tl.to(centerText, {
          autoAlpha: 1,
          y: 0,
          duration: 0.3,
          ease: "power2.out"
        });
        tl.to({}, { duration: 0.2 });
      }

      st = tl.scrollTrigger;
    }
    // 実行
    initCenterImageAnimation();

    gsap.to(".layer", {
      opacity: 0.6,
      ease: "none",
      scrollTrigger: {
        trigger: ".position_intr_wrap",
        start: "top top",
        end: "+=80%",
        scrub: true
      }
    });

    const sections = document.querySelectorAll(".positon_split_text");
    const images = document.querySelectorAll(".image");

    // 初期表示
    gsap.set(images[0], { opacity: 1 });

    sections.forEach((section, index) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top center",
        end: "bottom center",
        onEnter: () => switchImage(index),
        onEnterBack: () => switchImage(index),
      });
    });

    function switchImage(index) {
      images.forEach((img, i) => {
        if (i === index) {
          gsap.to(img, { opacity: 1, duration: 0.6 });
        } else {
          gsap.to(img, { opacity: 0, duration: 0.6 });
        }
      });
    }
  });

  mm.add("(max-width: 767.99px)", () => {

    gsap.to(".layer", {
      opacity: 0.6,
      ease: "none",
      scrollTrigger: {
        trigger: ".position_intr_wrap",
        start: "top top",
        end: "+=80%",
        scrub: true
      }
    });

  });

  // リサイズ時はデバウンス（少し待ってから実行）
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initCenterImageAnimation();
    }, 200);
  });

});